module.exports = __webpack_public_path__ + "img/dian.f93a778e.png";